(function () {
	const slideshow = () => {
		$(".slideshow-section").each(function () {
			if ($(this).hasClass('slider_started')){
				return ''
			}
			const slideCount = $(this).find(".swiper-slide").length;
			if (slideCount <= 1) {
				return;
			}
			$(this).addClass('slider_started');
			const id = $(this).attr("id");
			const box = $(this).find(".slideshow");
			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			} else {
				autoplayParm = {};
			}
			let swiperParms = {
				parallax: box.data("parallax"),
				speed: box.data("speed") * 1000,
				effect: box.data("effect"),
				loop: true,
				centeredSlides: false,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				creativeEffect: {
					prev: {
						shadow: true,
						translate: [0, 0, -400],
					},
					next: {
						translate: ["100%", 0, 0],
					},
				},
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: true,
				},
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
				...autoplayParm,
			};
			const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);
			colorScheme(swiper);
			swiper.on("beforeTransitionStart", function () {
				colorScheme(this);
			});
			function colorScheme(context) {
				const parent = $(context.el).parent();
				const activeIndex = context.activeIndex;
				const activeSlide = context.slides[activeIndex];
				const changeItems = [
					context.navigation.nextEl,
					context.navigation.prevEl,
					context.pagination.el,
				];
				const colorScheme = $(activeSlide)
					.find(".slideshow-slide")
					.data("color-scheme");
				changeItems.forEach((item) => {
					$(item)
						.removeClass("color-background-1")
						.removeClass("color-background-4")
						.addClass(colorScheme);
				});
			}
		});
	};

	const slideshowVideos = () => {
		document.querySelectorAll(".slideshow-slide__video").forEach(function (video) {
			if (video.dataset.bound) {
				return;
			}
			video.dataset.bound = "true";
			if (video.readyState >= 2) {
				video.classList.add("is-loaded");
				return;
			}
			video.addEventListener(
				"loadeddata",
				function () {
					video.classList.add("is-loaded");
				},
				{ once: true }
			);
		});
	};

	document.addEventListener("click", function (event) {
		const toggle = event.target.closest("[data-sound-toggle]");
		if (!toggle) {
			return;
		}
		const slide = toggle.closest(".slideshow-slide");
		const video = slide && slide.querySelector(".slideshow-slide__video");
		if (!video) {
			return;
		}
		video.muted = !video.muted;
		const isUnmuted = !video.muted;
		toggle.setAttribute("aria-pressed", isUnmuted ? "true" : "false");
		toggle.setAttribute(
			"aria-label",
			isUnmuted ? toggle.dataset.labelMute : toggle.dataset.labelUnmute
		);
	});

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		slideshowVideos();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
			slideshowVideos();
		});
	});
})();
